<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>
    <div class="order_msg">
      <div>
        <p>
          <span>您的收入</span>
          <span
            v-show="complainObj.state == 5"
            style="color:#EC130C;font-size:16px;"
          >+ ¥ {{complainObj.income}}</span>
          <span
            style="color:#2DAE19;font-size:16px;"
            v-show="complainObj.state != 5"
          >- ¥ {{complainObj.income}}</span>
        </p>
        <p>
          <span>订单金额</span>
          <span>￥{{complainObj.money}}</span>
        </p>
        <p>
          <span>订单号</span>
          <span>{{complainObj.orderSn}}</span>
        </p>
      </div>
      <div class="tips" v-show="complainObj.state != 5">用户撤销投诉后该笔金额将给回您</div>
      <!-- <p>
        <span>用户撤销投诉后该笔金额将给回您</span>
      </p>-->
    </div>
    <p class="bgcolor"></p>
    <div class="deduction_msg">
      <img :src="imgPrex + complainObj.headPic" alt />
      <div class="deductionList">
        <div class="deduction_header">
          <div>
            <span>{{complainObj.memberName}}</span>
            <span>{{complainObj.revokeTime}}</span>
          </div>
          <p>
            <span :class="{col:complainObj.state != 5}">{{complainObj.state == 5?'投诉已撤销':'未撤销'}}</span>
            <span v-show="complainObj.state == 5">{{complainObj.revokeTime}}</span>
          </p>
        </div>
        <p>{{complainObj.reason == 1?'商品不新鲜':complainObj.reason == 2?'商品质量问题':complainObj.reason == 3?'骚扰威胁':complainObj.reason == 4?'商品缺斤少两':'其他'}}</p>
        <span>{{complainObj.content}}</span>
        <div class="imgList">
          <img
            :src="imgPrex+item"
            alt
            v-for="(item,index) in complainObj.imgList"
            :key="index"
            @click="perviewImg(complainObj.imgList,index)"
          />
        </div>

        <div
          class="reply"
          v-show="complainObj.state > 1 && complainObj.sellerProcessingResult != ''"
        >
          <img :src="imgPrex + complainObj.sellerLogo" alt />
          <div class="replay_msg">
            <div>
              <span>{{complainObj.sellerName}} 回复:</span>
              <span>{{complainObj.sellerProcessingTime}}</span>
            </div>
            <p>{{complainObj.sellerProcessingResult}}</p>
          </div>
        </div>
      </div>
    </div>

    <van-button v-show="complainObj.state == 1" type="danger" class="btn" @click="tel">联系门店处理</van-button>
    <a :href="tels" v-show="show" id="tel">{{complainObj.sellerPhone}}</a>
  </div>
</template>

<script>
import { getDeductions } from "@/api/picker/index";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      show: false,
      headerMsg: {
        title: "扣款详情",
        url: "/"
      },
      complainObj: {}, //投诉详情obj
      imgPrex: this.imgPrex,
      tels: ""
    };
  },
  created() {
    console.log(this.$route.query.type);
    // this.$route.query.type == 0 ? this.headerMsg.title = "投诉处理详情" : this.headerMsg.title = "扣款详情"
  },
  mounted() {
    // this.$store.commit('user/SET_token', this.GetQueryString('token'))
    this.getDeductions();
    this.headerMsg.url = this.$store.getters.url;
  },
  methods: {
    // 拨打电话
    tel() {
      this.$dialog
        .confirm({
          message: this.complainObj.sellerPhone,
          confirmButtonText: "呼叫",
          confirmButtonColor: "#EC130C"
        })
        .then(() => {
          // on confirm
          // console.log(this.$refs.tel.el);
          document.getElementById("tel").click();
        })
        .catch(() => {
          // on cancel
        });
    },
    getDeductions() {
      // console.log(this.$store.getters.token)
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        id: this.$route.query.id // 扣款记录id
      };
      getDeductions(obj).then(res => {
        let dataInfo = res.content;
        if (dataInfo.memberUploadImages) {
          dataInfo.imgList = dataInfo.memberUploadImages.split(",");
        }
        this.tels = "tel:" + dataInfo.sellerPhone;
        this.complainObj = dataInfo;
      });
    },
    perviewImg(images, idx) {
      let list = [];
      for (let i = 0; i < images.length; i++) {
        list.push(this.imgPrex + images[i]);
      }
      ImagePreview({
        images: list,
        startPosition: 1,
        onClose() {
          // do something
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: rgba(255, 255, 255, 1);
  p {
    margin: 0;
  }
  .order_msg {
    width: 375px;
    height: 117px;
    // margin: 44px 0 0 0;
    background: rgba(255, 255, 255, 1);
    display: flex;
    position: relative;
    div {
      width: fit-content;
      height: 100%;
      p {
        width: 100%;
        height: 34px;
        margin: 0;
        display: flex;
        align-items: center;
        span {
          display: block;
          color: #1d1d1d;
        }
        span:first-child {
          width: 65px;
          height: 21px;
          margin-right: 15px;
          margin-left: 15px;
          font-size: 15px;
          color: #1d1d1d;
          text-align: left;
        }
        span:last-child {
          font-size: 15px;
        }
      }
      p:first-child {
        margin-top: 10px;
        span:last-child {
          color: #ec130c;
          font-weight: bold;
        }
      }
    }
    .tips {
      background-color: #fff2f2;
      font-size: 12px;
      color: #ec130c;
      width: 111px;
      height: 39px;
      position: absolute;
      top: 12px;
      right: 25px;
      padding: 4px 6px;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  .bgcolor {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
    margin: 0;
  }
  .deduction_msg {
    width: auto;
    height: 100%;
    display: flex;
    padding: 0 12.5px;
    img {
      width: 50px;
      height: 50px;
      display: block;
      margin: 15.5px 10.5px 0 0;
    }
    .deductionList {
      width: 100%;
      height: 100%;
      .deduction_header {
        width: 100%;
        height: 50px;
        display: flex;
        margin-top: 20.5px;
        margin-bottom: 10px;
        .col {
          color: #ec130c;
        }
        div {
          margin-right: auto;
          span {
            display: block;
            text-align: left;
          }
          span:first-child {
            color: #1d1d1d;
            font-size: 17px;
            font-weight: bold;
            margin-bottom: 4px;
          }
          span:last-child {
            color: #666;
            font-size: 14px;
          }
        }
        > p {
          display: flex;
          flex-flow: column;
          color: #666;
          margin-right: 22px;
          span:first-child {
            font-size: 18px;
            display: block;
            margin-bottom: 4px;
            font-weight: bold;
          }
          span:last-child {
            font-size: 12px;
          }
        }
      }
      > p {
        color: #1d1d1d;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
        text-align: left;
      }
      > span {
        display: block;
        color: #1d1d1d;
        font-size: 15px;
        margin-bottom: 10px;
        text-align: left;
      }
      .imgList {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        img {
          width: 94px;
          height: 94px;
          margin-right: 3px;
        }
        img:nth-child(3) {
          margin-right: 0px;
        }
        img:last-child {
          margin: 3px 0 0 0;
        }
      }
      .reply {
        width: 351px;
        height: 150px;
        background: rgba(245, 245, 245, 1);
        margin: 0px 0 20px -60px;
        display: flex;
        img {
          width: 30px;
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
          margin: 10.5px 10.5px 0 20.5px;
        }
        .replay_msg {
          div {
            display: flex;
            flex-flow: column;
            text-align: left;
            margin-top: 10px;
            span:first-child {
              color: #1d1d1d;
              font-size: 17px;
              font-weight: bold;
              margin-bottom: 3px;
            }
            span:last-child {
              color: #666;
              font-size: 14px;
            }
          }
          p {
            color: #1d1d1d;
            font-size: 15px;
            text-align: left;
            margin-top: 5px;
          }
        }
      }
    }
  }
  .btn {
    width: 351px;
    height: 45px;
    line-height: 45px;
    background: rgba(236, 19, 12, 1);
    border-radius: 5px;
    margin-top: 25px;
  }
}
/deep/.van-dialog__message {
  color: #1030d2;
}
</style>

